import { render, staticRenderFns } from "./intelRecommend.vue?vue&type=template&id=4b4eb7ca&scoped=true"
import script from "./intelRecommend.vue?vue&type=script&lang=js"
export * from "./intelRecommend.vue?vue&type=script&lang=js"
import style0 from "./intelRecommend.vue?vue&type=style&index=0&id=4b4eb7ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4eb7ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4eb7ca')) {
      api.createRecord('4b4eb7ca', component.options)
    } else {
      api.reload('4b4eb7ca', component.options)
    }
    module.hot.accept("./intelRecommend.vue?vue&type=template&id=4b4eb7ca&scoped=true", function () {
      api.rerender('4b4eb7ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/intelRecommend.vue"
export default component.exports